






































































import { Component, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import ModalGradePaper from '@/main-components/common/modal/ModalGradePaper.vue';
import { GradePaper } from '@/resource/grade/grade.model';
import { axios } from '@/utils/axios';
import CollectionLoading from '@/components/collections/CollectionLoading.vue';
import truncateString from '@/utils/common/truncate';

@Component({
  components: { MainButton, ModalGradePaper, CollectionLoading },
})
export default class GradePapersAdminPage extends Vue {
  isLoading = true;
  gradePapers: GradePaper[] = [];

  openModalGradePaper: any = null;

  created() {
    this.getGradePapers();
  }

  openModalGradePaperAdd(openModal: any) {
    this.openModalGradePaper = openModal;
  }

  async getGradePapers() {
    this.isLoading = true;
    try {
      const { data } = await axios.get('/grade-papers');

      if (data) {
        this.gradePapers = data as GradePaper[];
      }
    } catch (error) {
      console.log(error);
    }

    this.isLoading = false;
  }

  gradePaperClicked(gradePaper: GradePaper) {
    this.$router.push(`/auto-grades/${gradePaper.uuid}`);
  }

  truncateName(gradePaper: GradePaper) {
    return truncateString(gradePaper.name, 30);
  }
}
